"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubLabel = exports.Label = exports.Chevron = void 0;
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const Icon_1 = tslib_1.__importDefault(require("../../Icon"));
const styled_components_1 = tslib_1.__importDefault(require("../../Themes/styled-components"));
exports.Chevron = (0, styled_components_1.default)(Icon_1.default) `
  margin-left: ${(0, polished_1.rem)(12)};
`;
exports.Label = styled_components_1.default.div `
  color: ${({ theme }) => theme.textColor};
  font-weight: 500;
  font-size: ${(0, polished_1.rem)(14)};
  text-align: initial;
`;
exports.SubLabel = styled_components_1.default.div `
  margin-top: ${(0, polished_1.rem)(2)};
  font-size: ${(0, polished_1.rem)(12)};
  font-weight: normal;
  color: ${({ theme }) => theme.color.fadedText};
`;
